(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero2"] && !Shopify.designMode) return;
  try {
    
  const playHeroVideos = (hero) => {
    hero.querySelectorAll('video.hero__media').forEach((video) => {
      if (!(video instanceof HTMLVideoElement)) return;

      video.muted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');

      const attemptPlay = () => {
        const playPromise = video.play();
        if (playPromise?.catch) {
          playPromise.catch(() => {});
        }
      };

      if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
        attemptPlay();
      } else {
        video.addEventListener('loadeddata', attemptPlay, { once: true });
      }
    });
  };

  document.querySelectorAll('.hero').forEach(playHeroVideos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srikriti-collection-circles"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  if (!(event.target instanceof Element)) return;
  const root = event.target.closest('.srikriti-collection-circles');
  if (!root) return;
  if (event.target.closest('a[aria-disabled="true"]')) {
    event.preventDefault();
    return;
  }
  const button = event.target.closest('[data-sr-circles-prev], [data-sr-circles-next]');
  if (!button) return;
  const track = root.querySelector('[data-sr-circles-track]');
  const item = track && track.querySelector('.srikriti-collection-circles__item');
  if (!item) return;
  const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
  const step = item.getBoundingClientRect().width + gap;
  const direction = button.hasAttribute('data-sr-circles-next') ? 1 : -1;
  const rtl = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
  track.scrollBy({
    left: direction * rtl * step,
    behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srikriti-product-enhancements"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const localDateFormatter = new Intl.DateTimeFormat(undefined, {
      day: 'numeric',
      month: 'short'
    });
    let midnightTimer;

    function localDateAfter(days) {
      const date = new Date();
      date.setHours(12, 0, 0, 0);
      date.setDate(date.getDate() + days);
      return localDateFormatter.format(date);
    }

    function updateLocalJourneyDates() {
      document.querySelectorAll('[data-srikriti-local-date]').forEach((element) => {
        const startDays = Number(element.dataset.startDays || 0);
        const endDays = Number(element.dataset.endDays || startDays);
        const startDate = localDateAfter(startDays);
        const endDate = localDateAfter(endDays);
        element.textContent = startDays === endDays ? startDate : `${startDate}–${endDate}`;
      });
    }

    function scheduleLocalDateRefresh() {
      updateLocalJourneyDates();
      window.clearTimeout(midnightTimer);

      const now = new Date();
      const nextLocalMidnight = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1,
        0,
        0,
        1
      );

      midnightTimer = window.setTimeout(
        scheduleLocalDateRefresh,
        nextLocalMidnight.getTime() - now.getTime()
      );
    }

    scheduleLocalDateRefresh();
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) scheduleLocalDateRefresh();
    });
    window.addEventListener('pageshow', scheduleLocalDateRefresh);
    document.addEventListener('shopify:section:load', updateLocalJourneyDates);

    const sections = document.querySelectorAll('[data-srikriti-recommendations]');

    sections.forEach((container) => {
      if (container.querySelector('[data-srikriti-recommendations-content]')) return;

      fetch(container.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const page = new DOMParser().parseFromString(text, 'text/html');
          const content = page.querySelector('[data-srikriti-recommendations-content]');
          if (content) container.innerHTML = content.outerHTML;
        })
        .catch(() => {
          container.hidden = true;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
